import { environmentCommon } from './environment.common';

export const environment = {
	...environmentCommon,
	production: true,
	apiBaseUrl: 'https://server.stage.version47.com',
	imageUrl: 'https://assets.dev.version47.com/'
};
